import CharlieDisplayRegular from './CharlieDisplay-Regular.otf'
import CharlieDisplaySemiBold from './CharlieDisplay-Semibold.otf'
import CharlieDisplayThin from './CharlieDisplay-Thin.otf'
import CharlieTextRegular from './CharlieText-Regular.otf'

const fonts = {
  CharlieDisplaySemiBold,
  CharlieDisplayRegular,
  CharlieDisplayThin,
  CharlieTextRegular,
}

export default fonts
